import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../../../utils/Translations';
import {
	getGiftNameByLang, getTopUpGteThenValue,
}                   from '../../../../Dailybonus/dailyBonusHelpers';
import {getCurrencySymbol} from '../../../../../utils/CommonUtils.js';

class DailybonusMsgGiftOfferDescr extends React.Component {
	render() {
		const {
			      content, purchased, quantity, conditions,
		      }        = this.props;
		const gift     = getGiftNameByLang(content ? content.translations : []);
		const giftName = gift ? gift : 'Messenger-Gift';

		return (
			<div className='dailybonus__mobile--item__description'>
				<div className="dailybonus__mobile--item__description--bonus-title -gift">
					{purchased ? <span>{quantity}x {giftName}</span> : <span>{Translations.get('DailyBonusControllerInfoBonusGiftTitle')}</span>}
				</div>
				<div className="dailybonus__mobile--item__description--bonus-info h-text-light">
					{purchased ? <span>{Translations.get('MessengerGift365Received')}</span> :
						<span>{Translations.get('MessengerGift365Minimum', getTopUpGteThenValue(conditions))} {getCurrencySymbol()}</span>}
				</div>
			</div>
		);
	}
}

DailybonusMsgGiftOfferDescr.propTypes = {
	conditions: PropTypes.array,
	quantity:   PropTypes.number,
	content:    PropTypes.object,
	purchased:  PropTypes.bool,
};

DailybonusMsgGiftOfferDescr.defaultProps = {
	quantity:  0,
	purchased: false,
};

export default DailybonusMsgGiftOfferDescr;
